/**
 * @param {HTMLInputElement} element
 */
export default function triggerChange(element) {
    return element.dispatchEvent(new Event('change'));
}
